import { formatSingleItemWithStoryToBE } from './formatSingleItemWithStoryToBE'
import { formatSingleItemToBE } from './formatSingleItemToBE'

import { CUSTOMIZED_MEDIA_OPTION, UPLOAD_CUSTOMIZED_MEDIA } from '../../../../../fields'

import { FormatSingleImageOrVideoToBEParams, FormattedSingleImageOrVideo } from './types'
import { CustomizedWithStoryAdValues } from './formatSingleItemWithStoryToBE/types'
import { SingleItemValues } from './formatSingleItemToBE/types'

export const formatSingleImageOrVideoToBE = ({
  values,
  tags,
  selectedAdAccountId,
  lineItem
}: FormatSingleImageOrVideoToBEParams): FormattedSingleImageOrVideo => {
  const { [CUSTOMIZED_MEDIA_OPTION]: customizedMediaOption } = values

  if (customizedMediaOption === UPLOAD_CUSTOMIZED_MEDIA) {
    return formatSingleItemWithStoryToBE({
      values: values as CustomizedWithStoryAdValues,
      tags,
      selectedAdAccountId,
      lineItem
    })
  } else {
    return formatSingleItemToBE({
      values: values as SingleItemValues,
      tags,
      lineItem
    })
  }
}
